'use client';

import Script from 'next/script';
import { useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { colors } from '@/common/tokens.stylex';

export function ResetCMP() {
  const [consentLoaded, setConsentLoaded] = useState(false);

  return (
    <p {...stylex.props(styles.wrap)}>
      {consentLoaded && (
        <Script
          src="https://gdpr-tcfv2.sp-prod.net/wrapperMessagingWithoutDetection.js"
          onLoad={() => {
            window._sp_.loadPrivacyManagerModal(188325);
          }}
        />
      )}
      <button
        onClick={() => {
          if (window._sp_.loadPrivacyManagerModal) {
            window._sp_.loadPrivacyManagerModal(188325);
          } else {
            setConsentLoaded(true);
          }
        }}
        title="Cookie-Banner erneut aufrufen"
        {...stylex.props(styles.button)}
      >
        Zum Ändern der Präferenzen oder Widerruf der Einwilligung: Cookie-Banner
        erneut aufrufen
      </button>
    </p>
  );
}

const styles = stylex.create({
  wrap: {
    paddingBlock: 12,
    paddingInline: 0,
    maxWidth: 500,
    lineHeight: 1.625,
  },
  button: {
    cursor: 'pointer',
    color: colors.primaryColor,
    textAlign: 'left',
  },
});
